_ = require 'underscore'
ApiError = require 'app/scripts/network/api-error'
Auth = require 'app/scripts/db/auth'
ModelCache = require 'app/scripts/db/model-cache'
ModelLoader = require 'app/scripts/db/model-loader'
Payloads = require 'app/scripts/network/payloads'
Promise = require 'bluebird'
SidebarState = require 'app/scripts/view-models/sidebar-state'

module.exports = class RecentBoards
  _idBoardsFetching: []

  _fetchUnknownBoards: (idBoards, fetchUnknownBoardsCallback) ->
    idBoardsMissing = _.chain idBoards
    .difference @_idBoardsFetching
    .reject (idBoard) => ModelCache.get('Board', idBoard)?
    .value()

    return if idBoardsMissing.length == 0

    @_idBoardsFetching = @_idBoardsFetching.concat(idBoardsMissing)

    boards = idBoardsMissing.map (idBoard) =>
      ModelLoader.loadBoardData idBoard, Payloads.boardMinimal
      .catch ApiError.NotFound, ApiError.Unauthorized, ->
        SidebarState.pullBoard(idBoard)

    Promise.all boards
    .then =>
      @_idBoardsFetching = _.difference @_idBoardsFetching, idBoardsMissing
      if fetchUnknownBoardsCallback
        fetchUnknownBoardsCallback(idBoardsMissing)
      return
    .done()

  getBoards: (model, fetchUnknownBoardsCallback) ->
    me = Auth.me()
    _.chain SidebarState.getRecentBoards()
    .difference model.boardStarList.getBoardIds()
    .tap (idBoards) => @_fetchUnknownBoards(idBoards, fetchUnknownBoardsCallback)
    .map (idBoard) => ModelCache.get('Board', idBoard)
    .compact()
    .filter (board) => board.isViewableBy(me) && board.isOpen()
    .value()
